import { interval } from 'rxjs/observable/interval';
import { Coin, PriceFullRaw } from "./Coin";
import { HttpClient } from '@angular/common/http';
import { CMC } from './CoinMarketCap';
import { Subscription } from 'rxjs/Subscription';


export class PriceMap{
  currency: string = 'USD';
  map: {[name: string]: CoinEntry} = {};
  PRICES_SECOND: number = 40; //number of times the prices endpoint can be hit per second
  queue: string[] = []; //Queue of coin requests
  schedule: Subscription; //Schedule to fetch new prices
  SATOSHI_MULTIPLIER: number = 100000000;

  constructor(private http: HttpClient){
    // this.setSchedule(3000);
  }

  public getPrice(coin: Coin): PriceFullRaw{
    if(this.map[coin.Symbol]) return this.map[coin.Symbol].price;
    return null;
  }

  public refresh(){
    this.fillQueue();
    this.processQueue(null);
  }

  public setCurrency(currency: string, loader: any){
    this.currency = currency;
    //New currency, new prices
    this.fillQueue();
    this.processQueue(loader);
  }

  public addCoins(coins: Coin[]){
    for(let coin of coins){
      let entry = this.map[coin.Symbol];
      if(entry){
        entry.refCount++;
      }else{
        this.map[coin.Symbol] = {
          refCount: 1,
          coin: coin,
          price: null
        }
      }
    }
    //We want instant gratification
    this.fillQueue();
    this.processQueue(null);
  }

  public removeCoins(coins: Coin[]){
    for(let coin of coins){
      let entry = this.map[coin.Symbol];
      if(entry){
        entry.refCount--;
      }
    }
  }

  private processQueue(loader: any){
    let currency = (this.currency == 'Satoshi' ? 'BTC' : this.currency);
    if(this.queue.length == 0){
      if(loader){
        loader.dismiss();
        loader = null;
      }
      return;
    }

    let length = this.queue.length;
    for(let i = 0; i < length; i++){
      if(i >= this.PRICES_SECOND) break; //We don't want to excede our call limits
      this.http.get(this.queue.pop())
        .subscribe((response: CMC.PriceFullResponse) => {
          for(let name in response.RAW){
            //TODO: race condition on this.currency
            if(this.map[name]){
              let price = response.RAW[name][currency];
              if(this.currency == 'Satoshi'){
                price = this.convertToSatoshis(price);
              }
              this.map[name].price = price;
            }
          }
          //Close loader and set to null
          //TODO: only works for first request
          if(loader){
            loader.dismiss();
            loader = null;
          }
        }, error => {
          console.log(error);
          if(loader){
            loader.dismiss();
            loader = null;
          }
        });
    }
  }

  private setSchedule(mili: number){
    if(this.schedule) this.schedule.unsubscribe();

    const loop = interval(mili);
    this.schedule = loop.subscribe(val => {
      //Get block of urls to call
      this.processQueue(null);

      //Re-queue URLS
      if(this.queue.length == 0){
        this.fillQueue();
      }
    });
  }

  private fillQueue(){
    let coins: Coin[] = [];
    for(let name in this.map){
      if(this.map[name].refCount > 0){
        coins.push(this.map[name].coin);
      }
    }

    coins = this.shuffle(coins); //break cache

    let urls = this.getPriceURLs(coins);
    for(let url of urls){
      this.queue.push(url);
    }
    this.queue = this.queue.reverse(); //Turn a 1-time stack into a queue
  }

  private shuffle(array){

      var currentIndex = array.length, temporaryValue, randomIndex;

      // While there remain elements to shuffle...
      while (0 !== currentIndex) {

        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;


  }

  private getPriceURLs(coins: Coin[]): string[]{
    let list = [];
    let nameString = ""; //this is not to excede 100 chars
    let currency = (this.currency == 'Satoshi' ? 'BTC' : this.currency);
    for(let coin of coins){
      let name = coin.Symbol;
      if(nameString.length == 0){ //new string, no comma
        nameString += name;
      }else if((nameString.length + name.length + 1) < 100){ //There is room: chars + new name + preceding comma
        nameString += ',' + name;
      }else{ //no space, reset and add to list
        list.push(`https://min-api.cryptocompare.com/data/pricemultifull?fsyms=${nameString}&tsyms=${currency}`);
        nameString = "";
        nameString += name;
      }
    }

    //check for leftovers
    if(nameString.length > 0){
      list.push(`https://min-api.cryptocompare.com/data/pricemultifull?fsyms=${nameString}&tsyms=${currency}`);
    }
    return list;
  }

  private convertToSatoshis(price: PriceFullRaw): PriceFullRaw{
    const multi = this.SATOSHI_MULTIPLIER
    price.HIGH24HOUR *= multi;
    price.HIGHDAY *= multi;
    price.LASTVOLUME *= multi;
    price.LASTVOLUMETO *= multi;
    price.LOW24HOUR *= multi;
    price.LOWDAY *= multi;
    price.MKTCAP *= multi;
    price.OPEN24HOUR *= multi;
    price.OPENDAY *= multi;
    price.PRICE *= multi;
    price.SUPPLY *= multi;
    price.TOTALVOLUME24H *= multi;
    price.TOTALVOLUME24HTO *= multi;
    price.VOLUME24HOUR *= multi;
    price.VOLUME24HOURTO *= multi;
    price.VOLUMEDAY *= multi;
    price.VOLUMEDAYTO *= multi;
    return price;
  }

}

interface CoinEntry{
  refCount: number;
  coin: Coin;
  price: PriceFullRaw;
}



// WEBPACK FOOTER //
// ./src/models/PriceMap.ts